import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateCommunicationKitBody, UpdateCommunicationKitBody } from "@ac-expo/api-types";
import { privateAxios } from "../axiosInstances";
import { handleApiCall } from "../api-error-handler";
import { communicationKitQueryKeys } from "../query-keys";

const createCommunicationKit = (body: CreateCommunicationKitBody) =>
  handleApiCall(() => privateAxios.post("/communication-kits", body));

export const useCreateCommunicationKit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createCommunicationKit,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: communicationKitQueryKeys.all,
      });
    },
  });
};

const updateCommunicationKit = ({
  id,
  body,
}: {
  id: string;
  body: UpdateCommunicationKitBody;
}) => handleApiCall(() => privateAxios.patch(`/communication-kits/${id}`, body));

export const useUpdateCommunicationKit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateCommunicationKit,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: communicationKitQueryKeys.all,
      });
    },
  });
};

const deleteCommunicationKit = (id: string) =>
  handleApiCall(() => privateAxios.delete(`/communication-kits/${id}`));

export const useDeleteCommunicationKit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteCommunicationKit,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: communicationKitQueryKeys.all,
      });
    },
  });
};
